const Apiurl = "https://bs.aalantechsoft.com:5000/api";
// const Apiurl = "http://192.168.1.245:5000/api";
// const Apiurl = "http://192.168.1.105:5000/api";
// const Apiurl = "http://192.168.1.10:5000/api";

export default Apiurl;
